import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import moment from 'moment';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {  PowerBiReport } from '../../../interfaces/Organization';
import { IOrganizationService } from '../../../services/Interfaces/IOrganizationService';
import NumberFormat from 'react-number-format';

interface IPowerBiReportComponentState {
  newPowerBiReport: PowerBiReport;
  powerBiReports: PowerBiReport[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newPowerBiReportId: number | null;
}
type IPowerBiReportComponentProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class PowerBiReportComponent extends React.PureComponent<
  IPowerBiReportComponentProps,
  IPowerBiReportComponentState
> {
  private translatorService!: ITranslatorService;
  private organizationService!: IOrganizationService;
  static contextType = ApplicationContext;
  private newPowerBiReport = {
    id: 0
  } as PowerBiReport;

  state = {
    isLoading: false,
    isDialogOpen: false,
    newPowerBiReport: this.newPowerBiReport,
    powerBiReports: [],
    newPowerBiReportId: null
  } as IPowerBiReportComponentState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadPowerBiReports();
      }
    );
  }

  loadPowerBiReports = async () => {
    const powerBiReports = await this.organizationService.GetUserPowerBiReports();
    this.setState({
      powerBiReports: powerBiReports,
      isLoading: false,
      newPowerBiReport: { ...this.newPowerBiReport }
    });
  };

  private handleCodeChange = (value: string) => {
    this.setState({
      newPowerBiReport: {
        ...this.state.newPowerBiReport,
        code: value
      }
    });
  };

  private handleWorkspaceIdChange = (value: string) => {
    this.setState({
      newPowerBiReport: {
        ...this.state.newPowerBiReport,
        workspaceId: value
      }
    });
  };

  private handleReportIdChange = (value: string) => {
    this.setState({
      newPowerBiReport: {
        ...this.state.newPowerBiReport,
        reportId: value
      }
    });
  };

  public savePowerBiReport = async () => {
    if (this.state.newPowerBiReportId === null) {
      if (
        this.state.powerBiReports.findIndex(
          (item) => item.code === this.state.newPowerBiReport.code
        ) !== -1
      ) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'POWER_BI_REPORT_ALREADY_EXIST',
            'Exista deja o intrare pentru acest cod!'
          ),
          { variant: 'error' }
        );
        return;
      }
      try {
        await this.organizationService.AddPowerBiReport(this.state.newPowerBiReport);
        await this.loadPowerBiReports();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {
        await this.organizationService.UpdatePowerBiReport(this.state.newPowerBiReport);
        await this.loadPowerBiReports();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            },
            currentTarget: {
              value: values.value
            }
          });
        }}
        allowNegative={false}
        thousandSeparator={false}
        decimalScale={2}
      />
    );
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.savePowerBiReport} instantValidate={true}>
        <Box mb={2}>
          <TextValidator
            fullWidth
            name="code"
            id="code"
            value={this.state.newPowerBiReport.code || ''}
            onChange={(e: any) => this.handleCodeChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'POWER_BI_REPORT_CODE_LABEL',
              'Cod'
            )}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
          />
        </Box>
        <Box mb={2}>
          <TextValidator
            fullWidth
            name="workspaceId"
            id="workspaceId"
            value={this.state.newPowerBiReport.workspaceId || ''}
            onChange={(e: any) => this.handleWorkspaceIdChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'POWER_BI_REPORT_WORKSPACE_ID_LABEL',
              'Workspace Id'
            )}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
          />
        </Box>
        <Box mb={2}>
          <TextValidator
            fullWidth
            name="reportId"
            id="reportId"
            value={this.state.newPowerBiReport.reportId || ''}
            onChange={(e: any) => this.handleReportIdChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'POWER_BI_REPORT_REPORT_ID_LABEL',
              'Report Id'
            )}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
          />
        </Box>
        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeDialog}
          >
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
    </ValidatorForm>
    );
  }
  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'code',
        label: this.translatorService.Tranlate(
          'POWER_BI_REPORT_CODE_LABEL',
          'Code'
        )
      },
      {
        name: 'workspaceId',
        label: this.translatorService.Tranlate(
          'POWER_BI_REPORT_WORKSPACE_ID_LABEL',
          'Workspace Id'
        )
      },
      {
        name: 'reportId',
        label: this.translatorService.Tranlate(
          'POWER_BI_REPORT_REPORT_ID_LABEL',
          'Report Id'
        )
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newPowerBiReportPopup(tableMeta.rowData[0])}
                >
                    <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deletePowerBiReport(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }];
    return columns;
  };

  deletePowerBiReport = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      await this.organizationService.RemovePowerBiReport(id);
      await this.loadPowerBiReports();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newPowerBiReportPopup = async (powerBiReportId: number | null) => {
    let newPowerBiReport: PowerBiReport;
    if (powerBiReportId == null) {
      newPowerBiReport = { ...this.state.newPowerBiReport } as PowerBiReport;
    } else {
      newPowerBiReport = this.state.powerBiReports.find((item) => item.id === powerBiReportId)!;
    }
    this.setState({
      isDialogOpen: true,
      newPowerBiReport: newPowerBiReport,
      newPowerBiReportId: powerBiReportId
    });
  };

  closeDialog = async () => {
    this.setState(
        { 
          isDialogOpen: false, 
          newPowerBiReport: this.newPowerBiReport 
        }
      );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.organizationService = (this.context as AppContext).organizationService;

    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      // responsive: "stacked",
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newPowerBiReportPopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };
    return (
      <Fragment>
    
       <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.powerBiReports}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                  {!this.state.newPowerBiReportId ? 
                    this.translatorService.Tranlate(
                      'POWER_BI_REPORT_ADD_MODAL_TITLE',
                      'Adauga raport Power BI'
                    ) : this.translatorService.Tranlate(
                      'POWER_BI_REPORT_UPDATE_MODAL_TITLE',
                      'Actualizeaza raport Power BI'
                    )}               
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>) : null}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(PowerBiReportComponent as any));